module.exports = __webpack_public_path__ + "static/media/grid-world.3da8c01e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/grid-world.svg
// module id = 862
// module chunks = 0